import { render, staticRenderFns } from "./feedback-modal.vue?vue&type=template&id=27a6743f&"
import script from "./feedback-modal.vue?vue&type=script&lang=js&"
export * from "./feedback-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports